import React from "react";
import { ArrowRight, ShieldCheck, Images } from "lucide-react";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import { PageHero, Section, PrimaryButton, SecondaryButton } from "@/components/ui-helpers";

export default function Reviews() {
  return (
    <>
      <SEO title="Reviews" description="Verified client reviews for Ascendia Detail are being collected. See our real, unaltered before-and-after results in the meantime." />
      <PageHero kicker="Reviews" title="Verified reviews, coming soon" subtitle="We only publish reviews we can verify as genuine. While we collect them, the most honest proof of our work is the results themselves — real, unaltered before-and-after projects.">
        <PrimaryButton to="/contact">Request a Quote <ArrowRight className="h-4 w-4" /></PrimaryButton>
      </PageHero>
      <Section>
        <Reveal>
          <div className="ascendia-card card-accent-top mx-auto max-w-2xl p-8 sm:p-10 text-center">
            <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-gold/10 border border-[color:var(--border-subtle)]"><ShieldCheck className="h-6 w-6 text-gold-soft" strokeWidth={1.5} /></span>
            <h2 className="mt-5 font-display text-2xl font-semibold text-white u-tracking-tight">Real proof over polished words</h2>
            <p className="mt-3 text-secondary u-body">Rather than show unverified testimonials, we let our work speak. Explore genuine Ascendia transformations — never retouched or altered.</p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <SecondaryButton to="/gallery" data-testid="reviews-see-results-button"><Images className="h-4 w-4 text-gold-soft" /> See Real Results</SecondaryButton>
              <PrimaryButton to="/contact">Request a Quote <ArrowRight className="h-4 w-4" /></PrimaryButton>
            </div>
          </div>
        </Reveal>
      </Section>
    </>
  );
}
